<template>
    <div>
        <view-user v-if="!!item" :item="item" @toast="userCreated()"></view-user>

        <users-table title="Users" @addUser="showUserModal()" ref="userTable">
            <b-button block variant="primary" v-if="hasPermissionCreate" @click="createUser()"><img
                v-b-tooltip.hover :title="$translate('add')" src="@/assets/images/icon/blue-add.svg" /></b-button>
        </users-table>
    </div>
</template>
<script>
import UsersTable from './Users/UsersTable'
import utilityMixins from '@/mixins/utilityMixins'
import ViewUser from './Users/ViewUser'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'users',
    components: {
        UsersTable,
        ViewUser,
        // CreateUserForm,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data: () => {
        return {
            componentName: 'User',
            item: null,
        }
    },
    computed: {
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        createUser() {
            const id = 0;
            this.$router.push({ params: { id }, name: 'viewUsers' })
        },
        // userCreated() {
        //     this.genericToast(
        //         this.componentName,
        //         status,
        //         'success',
        //         `${this.componentName} ${status.toLowerCase()} succcessfully`
        //     )
        //     this.item = null
        //     this.$refs.userTable.doSearch()
        // },
    },

    mounted() { },
}
</script>
<style></style>
